export var debug = process.env.VUE_APP_DEBUG === 'true';
export var apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
export var apiAuth = '/oauth/token';
export var apiVersion = '/api/v3';
export var apiVersionParent = '/api/parent/v1';
